const actions = {
  async list(context, payload) {
    try {
      const response = await this.$api.call("commission.list", payload);

      context.commit("mutationCommissions", response);

      return response;
    } catch (error) {
      context.commit("mutationCommissions", []);
      throw error;
    }
  },

  async values(context, payload) {
    try {
      const response = await this.$api.call("commission.values", payload);
      const responseData = response.data;
      context.commit(
        "mutationCommissionValues",
        responseData?.userCommissions ?? [],
      );
      return response;
    } catch (error) {
      context.commit("mutationCommissionValues", []);
      throw error;
    }
  },

  async self(context, payload) {
    try {
      const response = await this.$api.call("commission.self", payload);
      const responseData = response.data;

      context.commit("mutationCommissionSelf", responseData);

      return response;
    } catch (error) {
      context.commit("mutationCommissionSelf", {});
      throw error;
    }
  },

  async detail(context, payload) {
    try {
      const response = await this.$api.call("commission.detail", payload);

      context.commit("mutationCommission", response);

      return response;
    } catch (error) {
      context.commit("mutationCommission", {});
      throw error;
    }
  },

  // this is used for lazy loading: reset store
  async resetDetailAll(context) {
    try {
      context.commit("mutationResetCommissionAll", {});
    } catch (error) {
      throw error;
    }
  },

  async listCommissionDetail(context, payload) {
    try {
      const response = await this.$api.call(
        "commission.listCommissionDetail",
        payload,
      );

      context.commit("mutationCommissionDetail", response.data);
      context.commit("mutationCommissionMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationCommissionDetail", []);
      context.commit("mutationCommissionMeta", {});
      throw error;
    }
  },

  async listCommissionDetailQuickView(context, payload) {
    try {
      const response = await this.$api.call(
        "commission.listCommissionDetailQuickView",
        payload,
      );

      context.commit("mutationCommissionDetailQuickView", response.data);

      return response;
    } catch (error) {
      context.commit("mutationCommissionDetailQuickView", []);
      throw error;
    }
  },

  async approveTransaction(_context, payload) {
    try {
      const response = await this.$api.call(
        "commission.approveTransaction",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async downloadCommissionDetailReports(_context, payload) {
    try {
      const response = await this.$api.call(
        "commission.downloadCommissionDetailReports",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
